import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const MarketingLayout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
